"use strict";

var Common            	= require( "../Common" );
var CommonGame         	= require( "../CommonGame" );


//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function ColourPencil() 
{
	// Constants.
	this.LINE_THICKNESS = 5;
	

	// Attributes.
	this._drawLayer = null;	
	this._colour = null;
}
module.exports               		= ColourPencil;
ColourPencil.prototype.constructor 	= ColourPencil;


//===================================================
//
// Public
//
//===================================================

ColourPencil.prototype.init = function( drawLayer ) 
{	
	this._drawLayer = drawLayer;		
};


//===================================================
//
// Private
//
//===================================================

ColourPencil.prototype._draw = function( from, to ) 
{  
	this._drawLayer.context.beginPath();
	this._drawLayer.context.strokeStyle = this._colour;
	this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
	this._drawLayer.context.lineJoin = "round";
	this._drawLayer.context.moveTo( from.x, from.y );
	this._drawLayer.context.lineTo( to.x, to.y );
	this._drawLayer.context.closePath();
	this._drawLayer.context.stroke();		

	this._drawLayer.onContext_Changed();	
};


//===================================================
//
// Events
//
//===================================================

ColourPencil.prototype.onDrawBegan = function( point ) 
{  
	this._draw( point, new PIXI.Point( point.x + 0.1, point.y + 0.1 ) );
};

ColourPencil.prototype.onDrawMoved = function( from, to ) 
{  
	this._draw( from, to );
};

ColourPencil.prototype.onDrawEnded = function() {};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
	ColourPencil.prototype, 
	"colour", 
	{ 	get: function() { return this._colour; },
		set: function( a ) { this._colour = a; } } );